import React from 'react';
import useStyles from './ApiKeysSettingsOverview.style';
import { TableCell, TableRow } from '@mui/material';
import UserAvatar from '../../Utilities/UserAvatar/UserAvatar.component';
import { Copy, PencilSimpleLine, Trash } from 'phosphor-react';
import { Button } from '@material-ui/core';

const ApiKeyTableItem = ({ apiKey, setCopyApiKeyModal, setEditApiKeyModal, setDeleteApiKeyModal }) => {
    const classes = useStyles();
    return (
        <TableRow key={apiKey.id}>
            <TableCell align="left" className={classes.tableCell}>
                {apiKey.plain_text_key}
            </TableCell>
            <TableCell align="center" className={classes.tableCell}>
                {apiKey.name}
            </TableCell>
            <TableCell align="center" className={classes.tableCell}>
                {apiKey.user && apiKey.user.first_name && apiKey.user.last_name ? (<div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <div className={classes.avatarWithName}>
                        <UserAvatar
                            avatar={""}
                            firstName={apiKey.user.first_name}
                            lastName={apiKey.user.last_name}
                        />
                        <span>
                            {apiKey.user.first_name} {apiKey.user.last_name}
                        </span>
                    </div>
                </div>) : "--"}
            </TableCell>
            <TableCell align="center" className={classes.tableCell}>
                {new Intl.DateTimeFormat("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    hour12: true,
                }).format(new Date(apiKey.created))}
            </TableCell>
            <TableCell align="center" className={classes.tableCell}>
                {apiKey.expires ? new Intl.DateTimeFormat("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                }).format(new Date(apiKey.expires)) : "No expiry"}
            </TableCell>
            <TableCell align="right" className={classes.tableCell}>
                <div className={classes.actionContainer}>
                    <Button
                        color="secondary"
                        onClick={() => setCopyApiKeyModal({ open: true, apiKey: apiKey.plain_text_key })}
                    >
                        <Copy size={20} />
                    </Button>
                    <Button
                        onClick={() => setEditApiKeyModal({
                            open: true,
                            data: apiKey
                        })}
                    >
                        <PencilSimpleLine size={20} color="#F9F9F9" />
                    </Button>
                    <Button
                        onClick={() => setDeleteApiKeyModal({ open: true, data: apiKey })}
                    >
                        <Trash size={20} color="#D61F1F" />
                    </Button>
                </div>
            </TableCell>
        </TableRow>
    )
}

export default ApiKeyTableItem
